<!--84 rename features-->
<div class="dx-field">
  <div class="dx-field-label">{{ 'Featuresystem Name' | translate }}</div>
  <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
    <label class="placeLabel {{ selectedFeatureSystem?.name?.length > 0 ? 'placeLabelSmall' : '' }}">REFERENCE FEATURESYSTEM NAME</label>
    <dx-select-box *ngIf="featureSystemsLoading == false"
                   [(value)]="selectedFeatureSystem"
                   [items]="featureSystems"
                   displayExpr="name"
                   [searchEnabled]="true"
                   [allowColumnResizing]="true"
                   (onValueChanged)="onFeatureSystemChanged($event)">
    </dx-select-box>
  </div>
</div>

<dx-load-indicator *ngIf="featureSystemsLoading" id="large-indicator" height="60" width="60"></dx-load-indicator>

<dx-data-grid *ngIf="selectedFeatureSystem && featuresDataSource"
              [dataSource]="featuresDataSource"
              [remoteOperations]="{ paging: true, sorting: true, filtering: true }"
              [showBorders]="true"
              noDataText="{{ 'RenameFeaturesMacroNoDataMessage' | translate }}"
              [style.marginTop.px]="25">
  <dxo-search-panel [visible]="true"></dxo-search-panel>
  <dxo-paging [pageSize]="50"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[20, 50, 100]" [showNavigationButtons]="true"></dxo-pager>
  <dxi-column dataField="name" sortOrder="asc" caption="{{ 'Ursprünglicher Name' | translate }}"></dxi-column>
  <dxi-column dataField="unit" caption="{{ 'Ursprüngliche Einheit' | translate }}"></dxi-column>
  <dxi-column caption="{{ 'Neuer Name' | translate }}" cellTemplate="newNameTemplate" [allowSorting]="false" [allowFiltering]="false"></dxi-column>
  <div *dxTemplate="let model of 'newNameTemplate'">
    <dx-text-box [value]="getNewName(model.data)" (onValueChanged)="setNewName(model.data, $event.value)" [showClearButton]="false"></dx-text-box>
  </div>
  <dxi-column caption="{{ 'Neue Einheit' | translate }}" cellTemplate="newUnitTemplate" [allowSorting]="false" [allowFiltering]="false"></dxi-column>
  <div *dxTemplate="let model of 'newUnitTemplate'">
    <dx-text-box [value]="getNewUnit(model.data)" (onValueChanged)="setNewUnit(model.data, $event.value)" [showClearButton]="false"></dx-text-box>
  </div>
</dx-data-grid>
